import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [Sentry.replayIntegration()],

  // Don't record normal sessions
  replaysSessionSampleRate: 0,

  // Record a replay for every session that has an error
  replaysOnErrorSampleRate: 1.0,

  // Reference a release
  release: import.meta.env.VITE_SENTRY_RELEASE,
});
